module.exports = __webpack_public_path__ + "img/3.4653b403.jpg";